import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef } from 'react';
import EmailIcon from '@rexlabs/icons/medium/email.svg';
import TextInput from './text-input';
var displayName = 'EmailInput';
export var EmailInput = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    placeholder: "Enter email address",
    Prefix: EmailIcon
  }, props, {
    type: "email",
    ref: ref
  }));
});
EmailInput.displayName = displayName;
export default EmailInput;